/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Instagram = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.226 23H12C10.2671 23 8.68493 22.9252 7.10274 22.8503C5.67123 22.7755 4.39041 22.2517 3.33562 21.4286C2.35616 20.6054 1.67808 19.483 1.30137 18.1361C1 16.9388 1 15.8163 1 14.6939V12V9.30612C1 8.18367 1 7.06122 1.30137 5.86395C1.67808 4.51701 2.35616 3.39456 3.33562 2.57143C4.39041 1.7483 5.67123 1.22449 7.10274 1.14966C8.68493 1.07483 10.2671 1 12 1C13.7329 1 15.3151 1.07483 16.8973 1.14966C18.3288 1.22449 19.6096 1.7483 20.6644 2.57143C21.6438 3.39456 22.3219 4.51701 22.6986 5.86395C23 7.06122 23 8.18367 23 9.30612V12V14.6939C23 15.8163 23 16.9388 22.6986 18.1361C22.3219 19.483 21.6438 20.6054 20.6644 21.4286C19.6096 22.2517 18.3288 22.7755 16.8973 22.8503C15.3904 22.9252 13.8836 23 12.226 23ZM11.7739 6.61211C8.76022 6.68694 6.4246 9.15633 6.49994 12.1495C6.57528 15.1427 9.06159 17.4625 12.0753 17.3876C15.089 17.3128 17.4246 14.8434 17.3493 11.8502C17.2739 8.85701 14.7876 6.53728 11.7739 6.61211ZM12.0753 15.6665C10.041 15.7414 8.3835 14.1699 8.30816 12.1495C8.23282 10.1291 9.81501 8.48286 11.8493 8.40803C13.8835 8.3332 15.541 9.90463 15.6164 11.925C15.6917 13.8706 14.1095 15.5917 12.0753 15.6665ZM19.233 6.16322C19.233 6.86579 18.6596 7.43533 17.9522 7.43533C17.2448 7.43533 16.6714 6.86579 16.6714 6.16322C16.6714 5.46066 17.2448 4.89111 17.9522 4.89111C18.6596 4.89111 19.233 5.46066 19.233 6.16322Z"
                        fill={color}
                    />
                </svg>
        );
    };
